var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldVideoAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.73 2.5c0-.28-.22-.5-.5-.5H9.77c-.28 0-.5.22-.5.5v3.36c0 .28.22.5.5.5h4.46c.28 0 .5-.22.5-.5V2.5zM2.289 5.7c-.1.33.14.66.48.66h4.5c.28 0 .5-.22.5-.5V2.52a.5.5 0 0 0-.52-.5c-2.56.16-4.31 1.48-4.96 3.68zM21.71 5.689c.1.33-.14.66-.48.66h-4.5c-.28 0-.5-.22-.5-.5v-3.34a.5.5 0 0 1 .52-.5c2.56.16 4.31 1.48 4.96 3.68z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.98 15.67c-.04-.06-.09-.12-.14-.17-.01-.01-.02-.03-.03-.04-.81-.9-2-1.46-3.31-1.46-1.26 0-2.41.52-3.23 1.36a4.5 4.5 0 0 0-.62 5.46c.22.37.5.71.82.99.02.01.03.02.04.03.05.05.1.09.16.14h.01c.01.01.02.02.03.02.75.63 1.72 1 2.79 1 1.64 0 3.07-.88 3.85-2.18.23-.39.41-.82.52-1.27.09-.34.13-.69.13-1.05 0-1.06-.37-2.04-1-2.8 0-.01-.01-.02-.02-.03zm-2.73 3.56v.97c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.97h-.93c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.93v-.89c0-.41.34-.75.75-.75s.75.34.75.75v.89h.93a.749.749 0 1 1 0 1.5h-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.74c0 .37-.39.61-.72.44a6.013 6.013 0 0 0-7.08 1.13 5.94 5.94 0 0 0-1.7 4.19c0 .81.32 1.85.72 2.72.16.35-.08.78-.47.78H7.81C4.6 22 2 19.4 2 16.19V8.36c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v4.38z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldVideoAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-video-add.afd28f5a4439c2cf4f70077b195a9f42.svg";
export { ForwardRef as ReactComponent };